import { render, staticRenderFns } from "./PaintStyleEditor.vue?vue&type=template&id=2556a0c0&scoped=true&"
import script from "./PaintStyleEditor.vue?vue&type=script&lang=ts&"
export * from "./PaintStyleEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PaintStyleEditor.vue?vue&type=style&index=0&id=2556a0c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2556a0c0",
  null
  
)

export default component.exports